import forEach from 'lodash/forEach';
import findIndex from 'lodash/findIndex';
import remove from 'lodash/remove';
import { ABNORMALITIES } from '../../constants';

export const isManifestBased = genericAbnormalityType =>
    genericAbnormalityType === 'MANIFEST_BASED';

export const comparingFunction = (a, b) => {
    if (a.manifestNumber < b.manifestNumber) {
        return -1;
    }
    if (a.manifestNumber > b.manifestNumber) {
        return 1;
    }

    if (a.manifestNumber === b.manifestNumber) {
        if (a.emcDockCode < b.emcDockCode) {
            return -1;
        }
        if (a.emcDockCode > b.emcDockCode) {
            return 1;
        }
        return 0;
    }
};

// add totalPallets property and recoveryActions array to abnormality manifests
export const addMetaDataToManifests = (manifests, abnormalityManifests) => {
    forEach(abnormalityManifests, abnMan => {
        forEach(manifests, man => {
            if (man.manifestId === abnMan.manifest.manifestId) {
                man.totalPallets = abnMan.totalPallets;
                man.recoveryActions = abnMan.recoveryActions;
                man.severity = abnMan.severity;
            }
        });
    });
    manifests.sort(comparingFunction);
    return manifests;
};

// add totalPallets property and recoveryActions array to abnormality manifests
export const composeManifestsWithMetaData = abnormalityManifests => {
    const manifests = [];

    forEach(abnormalityManifests, abnMan => {
        const manifestObj = {
            abnormalityId: abnMan.abnormalityId,
            abnormalityManifestId: abnMan.abnormalityManifestId,
            connectingRunTime: abnMan.manifest.connectingRunTime,
            emcCode: abnMan.manifest.emcCode,
            emcDelivery: abnMan.manifest.emcDelivery,
            emcDockCode: abnMan.manifest.emcDockCode,
            emcPlantCode: abnMan.manifest.emcPlantCode,
            manifestId: abnMan.manifest.manifestId,
            manifestNumber: abnMan.manifest.manifestNumber,
            pLaneExit: abnMan.manifest.pLaneExit,
            recoveryActions: abnMan.recoveryActions,
            severity: abnMan.severity,
            supplierCode: abnMan.manifest.supplierCode,
            supplierPlantCode: abnMan.manifest.supplierPlantCode,
            totalPallets: abnMan.totalPallets,
            ghost: abnMan.manifest.ghost,
        };
        manifests.push(manifestObj);
    });

    return manifests;
};

// insert to selectedManifests the ids of all manifests of the abnormality -> abnormalityManifestId
export const mapAbnormalityManifestsToSelectedManifests = (
    abnormalityManifests,
    selectedManifests
) => {
    forEach(abnormalityManifests, abnMan => {
        if (abnMan.manifest) {
            // it should always have a manifest anyway
            const index = selectedManifests.indexOf(abnMan.manifest.manifestId);
            if (index === -1) {
                // if it's not there already
                selectedManifests.push(abnMan.manifest.manifestId);
            }
        }
    });
    return selectedManifests;
};

// match the selected manifests [has ids] with the whole manifest object from the state [has current totalPallets]
export const mapWholeSelectedManifestObject = (selectedManifests, manifests) => {
    const filteredManifests = [];
    forEach(selectedManifests, sel => {
        forEach(manifests, man => {
            if (man.manifestId === sel) {
                filteredManifests.push(man);
            }
        });
    });
    return filteredManifests;
};

// make correct list of manifests by stop and abnormality manifests that have recovery actions
// note: manifestsByStop can be different than abnormalityManifests
export const makeDisplayedManifestsList = (manifestsByStop, abnormalityManifests) => {
    let correctList = [];
    if (manifestsByStop.length !== 0) {
        // manifestsByStop may be empty if manifests have slided
        correctList = manifestsByStop;
        forEach(abnormalityManifests, abnMan => {
            const index = findIndex(
                manifestsByStop,
                man => man.manifestId === abnMan.manifest.manifestId
            );
            if (index !== -1) {
                // and already exists in manifestsByStop list, replace it with the 'recovered' one
                remove(correctList, man => man.manifestId === abnMan.manifest.manifestId);
                correctList.push(abnMan.manifest);
            } else {
                // if it's not there push it
                correctList.push(abnMan.manifest);
            }
        });
    } else {
        // if manifestsByStop are empty return the abnormalityManifests
        forEach(abnormalityManifests, abnMan => {
            correctList.push(abnMan.manifest);
        });
    }
    correctList.sort(comparingFunction); // sort them according to manifestNumber (+ dock code)
    return correctList;
};

export const makeStopsList = run => {
    const stopsList = [];
    if (run) {
        forEach(run.wayPoints, wp => {
            forEach(wp.stops, stop => {
                stopsList.push(stop);
            });
        });
    }
    return stopsList;
};

export const abnormalityTypeCanHaveReceivedRun = abnormalityType =>
    abnormalityType === ABNORMALITIES.EARLY_FREIGHT ||
    abnormalityType === ABNORMALITIES.RETURN_FREIGHT;
